import { Intro } from "../../models/intro";
import * as IntroHelpers from '../../Intros/_IntroBase';
import NotificationUtil from "../../_notificationUtil";

let lazyIntro: Intro;

class DocumentTabIntro extends Intro {

    public Name: string = 'documentTabIntro';

    public AddSteps(): void {
        this.AddStep('Introduction', $('#document-tab-intro')[0], 'bottom', (currentStep, allStepCount) => {
            return IntroHelpers.introTemplateHeader('Információ gomb', currentStep, allStepCount) + 'Köszöntjük a megújult oldalon! A következőkben végig kalauzoljuk az újdonságokon. Ha nem szeretné most megnézni, kattintson a jobb felső sarokban található "X" gombra, a későbbiekben is bármikor megnézheti a bemutatót, erre a zöld i ikonra kattintva';
        });

        this.AddStep('PriorityTags', $('.priority-tags')[0], 'bottom', (currentStep, allStepCount) => {
            return IntroHelpers.introTemplateHeader('Címkék', currentStep, allStepCount) + 'A címkéket "drag-and-drop" módszerrel lehet egy sorra elhelyezni: a kiválasztott címkét az egérrel meg kell ragadni, és a gombot lenyomva tartva kell a sorra húzni azt. Lehetőség van tömeges szerkesztésre, azaz ha előzőleg több sort kijelöl, a kiválasztott címkét mindegyik sorra elhelyezi a rendszer.';
        });

        this.AddStep('AdditionalTags', $('#more-tags-toggle')[0], 'bottom', (currentStep, allStepCount) => {
            return IntroHelpers.introTemplateHeader('Több címke', currentStep, allStepCount) + 'A leggyakrabban használt címkéket alapértelmezetten elérhetővé tettük a felületen. Ha több címke közül szeretne választani, nyomjon a "Még több címke" gombra!';
        });

        this.AddStep('TagFilter', $('.tag-elements')[0], 'bottom', (currentStep, allStepCount) => {
            return IntroHelpers.introTemplateHeader('Címkék szűrése', currentStep, allStepCount) + 'Kattintson az egyik címkére! A táblázatban csak azok sorok jelennek meg, melyeken megtalálható a kiválasztott címke. Több címkét is kijelölhet: ebben az esetben minden olyan sor látszódik amelyeken legalább az egyik rajta van.';
        });

        this.AddStep('MassDownload', $('#mass-download-info')[0], 'bottom', (currentStep, allStepCount) => {
            return IntroHelpers.introTemplateHeader('Tömeges letöltés', currentStep, allStepCount) + 'A tömeges letöltés az ÉTDR régi, technikai felépítése miatt nem megvalósítható. A böngészőkhöz ún. add-on-t készítettünk, melyek telepítésével és beállításával megvalósítható a fájlok tömeges letöltése. Ehhez segítséget itt talál.';
        });

        this.AddStep('ColumnOrder', $('tr#uploadedDocs_DXHeadersRow0')[0], 'bottom', (currentStep, allStepCount) => {
            return IntroHelpers.introTemplateHeader('Oszlopok sorrendje', currentStep, allStepCount) + 'Az oszlopokat tetszőleges sorrendbe rendezheti, mely beállítást a böngészője eltárolja. Fogja meg az oszlop fejlécét, és húzza a kívánt helyre!';
        });

        this.AddStep('Filtering', $('#uploadedDocs_DXFREditorcol7 #uploadedDocs_DXFREditorcol7_B-1')[0], 'bottom', (currentStep, allStepCount) => {
            return IntroHelpers.introTemplateHeader('Szűrések', currentStep, allStepCount) + 'A "Feltöltés ideje" oszlopban mostantól a dátum pontos kiválasztását dátumválasztó segíti. Használja a tölcsér ikont, ha korábbi vagy későbbi dátumokra keres! A többi oszlopban a megszokott módon kereshet.';
        });

        this.AddStep('ExpandRows', $('#uploadedDocs_tccell0_1')[0], 'right', (currentStep, allStepCount) => {
            return IntroHelpers.introTemplateHeader('Sorok lenyitása', currentStep, allStepCount) + 'A nyíl ikonnal le tudja nyitni a sort. A megjelenő részen az látszódik, hogy az adott sor mely másik dokumentumhoz lett csatolva. (Pl. a kiválasztott tervlap a kérelem vagy a hiánypótlás részeként lett-e beadva.)';
        });

        let $firstRow: JQuery = $('#uploadedDocs_DXDataRow0');
        this.AddStep('', $firstRow.children('td.batch-editable:not(".dx-ar")')[0], 'bottom', (currentStep, allStepCount) => {
            return IntroHelpers.introTemplateHeader('Cella szerkesztése', currentStep, allStepCount) + 'A táblázat "Sorszám" és "Típus / Megjegyzés" celláinak tartalma kattintást követően szerkeszthetőek - a rendszer nem navigál többé új oldalra emiatt. A "Tab" billentyű megnyomásával a következő szerkeszthető cellába tud ugrani. A változásokat szükséges elmenteni a táblázat jobb felső sarkában elhelyezett "Mentés" gombbal.';
        });

        this.AddStep('Download', $('#uploadedDocs_tccell0_5')[0], 'bottom', (currentStep, allStepCount) => {
            return IntroHelpers.introTemplateHeader('Letöltés', currentStep, allStepCount) + 'A táblázat "Fájlnév" oszlopának cellájában történő kattintásra elindul a fájl letöltése az aktuális böngésző beállításának függvényében.';
        });

        this.AddStep('HiddenDocuments', $('#hidden-document-filter-switch-wrapper')[0], 'bottom', (currentStep, allStepCount) => {
            return IntroHelpers.introTemplateHeader('Elrejtés', currentStep, allStepCount)
                + 'Új címkét vezettünk be, mellyel a dokumentumok elrejthetőek. A "rejtett" címkét az adott sorra ráhúzva, bármikor elrejtheti az adott dokumentumot, legyen az irat, terv, vagy más dokumentum. Az elrejtett dokumentum nem törlődik, viszont az új nézetben nem fog megjelenni a listában. A címkét törölve a dokumentumokat bármikor vissza tudja állítani.'
        });

        this.AddStep('HiddenDocumentsSwitch', $("#fake-switch-for-intro-js")[0], 'right', (currentStep, allStepCount) => {
            return IntroHelpers.introTemplateHeader('Nézet választó', currentStep, allStepCount)
                + 'Ezzel a kapcsolóval rejtheti el vagy hozhatja elő a "rejtett" címkét tartalmazó dokumentumokat. A kapcsoló másik eljárásban is és kilépés után is abban az állapotban marad, ahogy legutoljára hagyta.';
        });

        this.AddStep('Refresh', $('#documentlist-refresh-btn')[0], 'right', (currentStep, allStepCount) => {
            return IntroHelpers.introTemplateHeader('Frissítés', currentStep, allStepCount)
                + 'A „rejtett” címke elhelyezésekor a sor nem tűnik el azonnal, a következő újratöltésig látható lesz. A táblázat újratöltéshez használhatja ezt a gombot.';
        });

        this.AddStep('Epilogue', $('#uploadedDocs')[0], 'top', (currentStep, allStepCount) => {
            return IntroHelpers.introTemplateHeader('Vége', currentStep, allStepCount) + 'Köszönjük, hogy megnézte a bemutatót! Reméljük, hogy az új funkciók segítik a munkáját!';
        });
    }

    protected OnChange(toStep: string): void {
        let additionalTagsToggle = $('#more-tags-toggle')[0];

        if (toStep === 'AdditionalTags') {
            OpenAdditionalTags();
        } else {
            CloseAdditionaltags();
        }

        if (toStep === 'HiddenDocumentsSwitch') {
            setZIndexOfCustomSwitch();
        } else {
            unSetZIndexOfCustomSwitch();
        }

        function OpenAdditionalTags(): void {
            let isExpanded = additionalTagsToggle.getAttribute('aria-expanded') === 'true';
            if (!isExpanded) {
                additionalTagsToggle.click();
            }
        }

        function CloseAdditionaltags(): void {
            let isExpanded = additionalTagsToggle.getAttribute('aria-expanded') === 'true';
            if (isExpanded) {
                additionalTagsToggle.click();
            }
        }

        function setZIndexOfCustomSwitch() {
            let $fakeSwitch: JQuery = $("label[for='hidden-documents-display-switch']");
            $fakeSwitch.addClass('biggest-z-index');
        }

        function unSetZIndexOfCustomSwitch() {
            let $fakeSwitch: JQuery = $("label[for='hidden-documents-display-switch']");
            $fakeSwitch.removeClass('biggest-z-index');
        }
    }
}

export function StartDocumentTabIntro(): void {
    if (GridHasAtLeastOneVisibleRow()) {
        let intro: Intro = lazyIntro || new DocumentTabIntro();
        intro.Start();
    }
    else {
        NotificationUtil.Info('A bemutató csak akkor indul el, ha nem üres a táblázat.');
    }
}

export function AutoStartDocumentTabIntro(): void {
    if (GridHasAtLeastOneVisibleRow()) {
        let intro: Intro = lazyIntro || new DocumentTabIntro();
        intro.AutoStart();
    }
}

function GridHasAtLeastOneVisibleRow() {
    let grid: MVCxClientGridView = window['uploadedDocs'] as MVCxClientGridView;
    return grid.GetVisibleRowsOnPage() > 0;
}
